import React from 'react'
import { Truckbody, Tires, Road } from "./AllSvg";


const Loader = () => {
    return (
        <>
            <div className="loader">
                <div className="truckWrapper">
                    <div className="truckBody">
                        <Truckbody />
                    </div>
                    <div class="truckTires">
                        <Tires />
                        <Tires />
                    </div>
                    <div className="road"></div>
                    <Road />
                </div>
            </div>
        </>
    )
}
export default Loader